export function Url2FileFilter() {
  return function (url) {
    return url ? url.split('/').pop() : url
  }
}
